import gql from 'graphql-tag';
import { EMPLOYEE_TYPE } from './EmployeeType.gql';

export const DELETE_EMPLOYEE = gql`
  ${EMPLOYEE_TYPE}
  mutation deleteEmployee($id: ID!) {
    deleteEmployee(id: $id) {
      employee {
        ...EmployeeType
      }
    }
  }
`;
